import { Heading } from '~src/components/display';
import { useLocalization } from '~src/hooks';

import { InstallationGuideEntry } from './InstallationGuideEntry';
import { InstallationGuideImages } from './InstallationGuideImages';
import { InstallationGuideSectionProps } from './types';
import { formatYesOrNo, getRelayTranslation } from './util';

import { informationColumn, installationGuideSectionHeader } from './installationGuide.module.css';

export const InstallationGuideElectricitySolar = ({ answerMap, imageList }: InstallationGuideSectionProps) => {
  const translate = useLocalization();

  return (
    <div>
      <Heading className={installationGuideSectionHeader} level={2}>
        {translate.ELECTRICITY_PANEL}
      </Heading>

      <div className={informationColumn}>
        {!!answerMap?.electricRelayAutoSafetyAndExtra?.answer && (
          <InstallationGuideEntry
            label={translate.SITE_VISIT_QUESTION_SOLAR_ELECTRICITY_RELAY}
            value={getRelayTranslation(translate, answerMap?.electricRelayAutoSafetyAndExtra?.answer)}
          />
        )}

        {!!answerMap?.wiringInCeilingForSolar?.answer && (
          <InstallationGuideEntry
            label={translate.SITE_VISIT_QUESTION_SOLAR_ELECTRICITY_WIRE_PLACEMENT}
            value={formatYesOrNo(translate, answerMap?.wiringInCeilingForSolar?.answer)}
          />
        )}

        {!!answerMap?.electricitySolarNotes?.answer && (
          <InstallationGuideEntry label={translate.NOTES} value={answerMap?.electricitySolarNotes?.answer} />
        )}

        <InstallationGuideImages imageList={imageList} />
      </div>
    </div>
  );
};
